import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import type { AuthSession, AuthState } from './auth-session';
import { CHALLENGE_ROUTES } from './require-auth';

/**
 * O `navigateToFlow` do legado: depois de cada passo, vai para o desafio pendente ou, com sessão
 * completa, para o destino guardado (ou `/`). Falha fica na tela.
 */
export function useAuthNavigation(session: AuthSession) {
  const navigate = useNavigate();
  return useCallback(
    async (state: AuthState) => {
      if (state.status === 'signedIn') {
        await navigate({ href: session.consumeRedirect(), replace: true });
        return;
      }
      if (state.status === 'challenge' && state.challenge) {
        await navigate({ to: CHALLENGE_ROUTES[state.challenge] });
      }
    },
    [navigate, session],
  );
}
